// extracted by mini-css-extract-plugin
module.exports = {"altHero":"rm","altProd":"sm","subheading":"tm","subtext":"um","extrainfo":"vm","copy":"wm","cta":"xm","disabled":"ym"};